// @ts-nocheck



import React, { Component, Fragment } from 'react';
import styled, { css } from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { Item as FormItem } from 'antd/lib/form';







import Selects from './../../../components/selects';
import { Icon as UiIcon } from '../../../components/ui';

const ItemCol = styled.div.withConfig({ displayName: "RepairOrderVehicleAddRow__ItemCol", componentId: "sc-yg1x0r-0" })(["", ";"],
(props) => css(["", ";"],
props.width ? `width: ${props.width}px;` : `flex: ${props.flex || 1};`));



const Wrapper = styled.div.withConfig({ displayName: "RepairOrderVehicleAddRow__Wrapper", componentId: "sc-yg1x0r-1" })(["display:flex;flex-direction:row;box-sizing:border-box;align-items:flex-start;> .col-item{padding:0 8px;text-align:center;vertical-align:middle;&:first-child{padding-left:0;}&:last-child{padding-right:0;}}"]);



















const OperationCol = styled(ItemCol).withConfig({ displayName: "RepairOrderVehicleAddRow__OperationCol", componentId: "sc-yg1x0r-2" })(["height:32px;"]);



const StyledIcon = styled(UiIcon).withConfig({ displayName: "RepairOrderVehicleAddRow__StyledIcon", componentId: "sc-yg1x0r-3" })(["margin-top:8px;cursor:pointer;"]);




const { VehicleSelect, MaintenanceOperationSelect } = Selects;











/**
 * Строка редактирования мойки ТС
 */
export default class RepairOrderVehicleRow extends Component {
  state = {
    repairOrderVehicle: {},
    errors: {}
  };

  validate = () => {
    const { repairOrderVehicle } = this.state;
    var errors = {};
    if (!repairOrderVehicle.vehicleId) {
      errors.vehicleId = 'Обязательно для заполнения';
    }
    if (!repairOrderVehicle.operations) {
      errors.operations = 'Обязательно для заполнения';
    }
    this.setState({
      errors
    });
    return errors;
  };

  onChange = (repairOrderVehicle) =>
  this.setState({
    repairOrderVehicle
  });

  render() {
    const { onAdd } = this.props;
    const { repairOrderVehicle, errors } = this.state;
    return (
      <Fragment>
        <Wrapper className="list-row-item">
          <ItemCol
            flex={1}
            className="col-item"
            style={{ maxWidth: 'calc(100% - 500px)' }}>

            <FormItem
              validateStatus={errors.vehicleId && 'error'}
              help={errors.vehicleId}>

              <VehicleSelect
                value={repairOrderVehicle.vehicleId}
                onChange={(vehicleId, selectedOption) => {
                  const newRepairOrderVehicle = {
                    ...repairOrderVehicle,
                    vehicleId: parseInt(vehicleId),
                    vehicle: selectedOption.props.vehicle
                  };
                  this.onChange(newRepairOrderVehicle);
                }} />

            </FormItem>
          </ItemCol>
          <ItemCol flex={1} className="col-item">
            <FormItem
              validateStatus={errors.type && 'error'}
              help={errors.type}>

              <MaintenanceOperationSelect
                onChange={(value, selectedOptions) =>
                this.onChange({
                  ...repairOrderVehicle,
                  operations: selectedOptions.map((option) => {
                    const maintenanceOperation =
                    option.props.maintenanceoperation;
                    return {
                      operation: maintenanceOperation,
                      operationId: maintenanceOperation.id,
                      count: 1
                    };
                  })
                })
                }
                value={
                repairOrderVehicle &&
                repairOrderVehicle.operations &&
                repairOrderVehicle.operations.map(
                  (repairOrderOperation) =>
                  repairOrderOperation.operation.id
                )
                }
                mode="multiple" />

            </FormItem>
          </ItemCol>
          <OperationCol width={35} className="col-item">
            {onAdd &&
            <StyledIcon
              type="plus"
              onClick={
              isEmpty(errors) && !isEmpty(repairOrderVehicle) ?
              () => {
                onAdd(repairOrderVehicle);
                this.setState({
                  repairOrderVehicle: {}
                });
              } :
              null
              } />

            }
          </OperationCol>
        </Wrapper>
      </Fragment>);

  }
}
